<template>
    <MainContent :title="'Venta de abonos ' + configuracion.simpatizantes">
        <template v-slot:header>
            <h3 class="card-title text-uppercase">{{ configuracion.simpatizantes }}</h3>
        </template>
        <template v-slot:content>
            <div class="row">
                <div class="col-12" id="inicio">
                    <TitleComponent :title="'1. Nº de ' + configuracion.simpatizantes" subtitle=""></TitleComponent>
                </div>
                <div class="col-12">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="metodo_pago">Número de {{ configuracion.simpatizantes }}</label>
                            <multiselect v-model="n_simpatizantes" :options="[1, 2, 3, 4, 5, 6, 7, 8]" name="n_simpatizantes" :allowEmpty="false" id="n_simpatizantes" :show-labels="false"></multiselect>
                        </div>
                    </div>
                </div>
                <div class="col-12 mb-3">
                    <Button @click.prevent="finalizarPasoUno">Continuar</Button>
                </div>
                <div class="col-12" v-if="datos" id="datos">
                    <TitleComponent :title="'2. Datos de los ' + configuracion.simpatizantes" subtitle=""></TitleComponent>
                </div>
                <div class="col-12" v-if="datos">
                    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                        <div class="row">
                            <template v-for="(abonado, index) in datos_abonados">
                                <div class="col-4" :key="index">
                                    <div class="card">
                                        <div class="card-header bg-secondary">
                                            <span class="text-capitalize">{{ configuracion.simpatizante }} - {{ ++index }}</span>
                                        </div>
                                        <div class="card-body">
                                            <div class="col-12">
                                                <FormInput label="Nombre" :name="'nombre' + index" rules="required" v-model="abonado.nombre" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Apellidos" :name="'apellidos' + index" rules="required" v-model="abonado.apellidos" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Dni" :name="'dni' + index" rules="required" v-model="abonado.dni" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Fecha de nacimiento" type="date" :name="'fecha_nacimiento' + index" rules="required" min="1900-01-01" v-model="abonado.fecha_nacimiento" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Email" type="email" :name="'email' + index" rules="required" v-model="abonado.email" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Teléfono" :name="'telefono' + index" rules="required" v-model="abonado.telefono" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Provincia" :name="'provincia' + index" rules="required" v-model="abonado.provincia" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Localidad" :name="'localidad' + index" rules="required" v-model="abonado.localidad" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="Domicilio" :name="'domicilio' + index" rules="required" v-model="abonado.domicilio" />
                                            </div>
                                            <div class="col-12">
                                                <FormInput label="CP/ZIP CODE" :name="'cp' + index" rules="required" v-model="abonado.codigo_postal" />
                                            </div>
                                            <template v-if="permisos['venta.descuento']">
                                                <div class="col-12 form-group">
                                                    <label for="descuento">Descuento en %</label>
                                                    <ValidationProvider :name="'descuento_total' + index" rules="required" v-slot="{ errors }">
                                                        <select :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" name="descuento" v-model="abonado.descuento_aplicado" @change="abonado.descuento_integro = 0">
                                                            <option value="0">Sin descuento</option>
                                                            <template v-for="(descuento, index) in configuracion.descuento_aplicado">
                                                                <option :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                                                            </template>
                                                        </select>
                                                    </ValidationProvider>
                                                </div>
                                                <div class="col-12 form-group">
                                                    <label for="nombre">Descuento en €</label>
                                                    <ValidationProvider :name="'descuento en €' + index" rules="required|double" v-slot="{ errors }">
                                                        <input :disabled="abonado.descuento_aplicado !='0'" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Descuento en €" v-model="abonado.descuento_integro">
                                                    </ValidationProvider>
                                                </div>
                                            </template>
                                            <div class="col-12">
                                                <div class="form-group">
                                                    <label for="descuento">Selecciona el tipo de abono</label>
                                                    <ValidationProvider :name="'precio' + index" rules="required" v-slot="{ errors }">
                                                        <multiselect
                                                            :class="(errors[0] ? 'is-invalid' : '')"
                                                            v-model="abonado.tipo_abono"
                                                            placeholder="Tipo de abono"
                                                            label="descripcion"
                                                            track-by="id"
                                                            :options="precios"
                                                            id="tipo-abono"
                                                        ></multiselect>
                                                        <small v-if="errors[0]" class="text-danger error">Seleccione un tipo de abono</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                            <div class="col-12" v-if="abonado.tipo_abono">
                                                <div class="form-group">
                                                    <label for="descuento">Selecciona tipo de precio</label>
                                                    <ValidationProvider :name="'descuento' + index" rules="required" v-slot="{ errors }">
                                                        <multiselect
                                                            :class="(errors[0] ? 'is-invalid' : '')"
                                                            v-model="abonado.descuento"
                                                            placeholder="Descuento"
                                                            label="descripcion"
                                                            track-by="id"
                                                            :options="abonado.tipo_abono.descuentos"
                                                            id="tipo-descuento"
                                                        ></multiselect>
                                                        <small v-if="errors[0]" class="text-danger error">Seleccione un tipo de abono</small>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="col-12">
                            <div class="form-group">
                                <label for="metodo_pago">Método de pago</label>
                                <ValidationProvider name="metodo_pago" rules="required" v-slot="{ errors }">
                                    <multiselect v-model="forma_pago" :options="metodos_pago" name="metodo_pago" label="nombre" :allowEmpty="false" :showLabels="false" id="metodo_pago"></multiselect>
                                    <small v-if="errors[0]" class="text-danger">Seleccione un método de pago</small>
                                </ValidationProvider>
                            </div>
                        </div>
                        <div class="col-12 text-right">
                            <Button type="submit" name="button" :disabled="loading">CONTINUAR</Button>
                        </div>
                    </ValidationObserver>
                </div>
                <div class="col-12" v-if="resumen" id="resumen">
                    <TitleComponent title="3. Resumen de la compra" subtitle=""></TitleComponent>
                </div>
                <div class="col-12" v-if="resumen">
                    <div class="row">
                        <template v-for="(abonado, index) in datos_abonados">
                            <div :key="index + 'd'" class="col-12 mt-3">
                                <div class="card bg-light">
                                    <div class="card-header">
                                        <strong class="text-primary text-uppercase">{{ configuracion.simpatizantes }} {{ i = index + 1 }} </strong>
                                    </div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-6" :key="index">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <span class="h4 text-uppercase"><strong>{{ abonado.nombre }} {{ abonado.apellidos }}</strong></span>
                                                    </div>
                                                    <div class="col-12">
                                                        <i class="fas fa-id-card"></i> {{ abonado.dni }}
                                                    </div>
                                                    <div class="col-12">
                                                        <i class="fas fa-envelope"></i> {{ abonado.email }}
                                                    </div>
                                                    <div class="col-12">
                                                        <i class="fas fa-phone"></i> {{ abonado.telefono }}
                                                    </div>
                                                    <div class="col-12" v-if="compra_finalizada">
                                                        <Button :href="urls_imprimir[index]" target="blank_">IMPRIMIR ABONO</Button>
                                                    </div>
                                                </div>
                                            </div>
                                            <div  class="col-6" :key="index + 'a'">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <strong>TIPO DE ABONO</strong>
                                                    </div>
                                                    <div class="col-12">
                                                        <span class="h3 text-uppercase"><strong>{{ abonado.descuento.descripcion }}</strong></span>
                                                    </div>
                                                    <div class="col-12">
                                                        <span class="h4" v-if="totalAbono(abonado) == 0"><strong>{{ abonado.descuento.precio_total_taquilla | formatear_precio }}</strong></span>
                                                        <span v-else> <strike class="pr-3">{{ abonado.descuento.precio_total_taquilla | formatear_precio }}</strike>  <strong>{{ totalAbono(abonado) | formatear_precio }}</strong></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="col-12">
                            <strong v-if="total_descuento == 0">TOTAL: <span class="h1"><strong>{{ total | formatear_precio }}</strong></span></strong>
                            <strong v-else>TOTAL: <span class="h1"><strike class="pr-5">{{ total | formatear_precio }}</strike> <strong>{{ total_descuento | formatear_precio }}</strong></span></strong>
                        </div>
                        <div class="col-12">
                            <strong>FORMA DE PAGO: <span class="h3"><strong>{{ forma_pago.nombre }}</strong></span></strong>
                        </div>
                        <div class="col-12 text-right" v-if="!compra_finalizada && !loading">
                            <Button name="button" @click.prevent="finalizar">TERMINAR COMPRA</Button>
                        </div>
                        <div class="col-12" v-if="loading" style="height: 120px">
                            <LoaderComponent></LoaderComponent>
                        </div>
                        <div class="col-12 text-right" v-if="compra_finalizada">
                            <Button name="button" @click.prevent="reset">EMPEZAR DE NUEVO</Button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </MainContent>
</template>

<script>
import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
import MainContent from "../../../components/backend/components/MainContent";

export default {
    data() {
        return {
            loading: false,
            metodos_pago: null,
            precios: [],
            resumen: false,
            n_simpatizantes: 1,
            datos: false,
            datos_abonados: [],
            forma_pago: {},
            urls_imprimir: null,
            compra_finalizada: null
        }
    },
    created() {
        this.getPrecios();
        this.metodos_pago = this.teatro.metodos_pago_abonos_bases.slice();

        this.borrarMetodoDePago(this.metodos_pago, 5);
        this.borrarMetodoDePago(this.metodos_pago, 8);
        this.borrarMetodoDePago(this.metodos_pago, 9);
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        total() {
            var total = 0;

            for (var i = 0; i < this.datos_abonados.length; i++) {
                total = total + parseFloat(this.datos_abonados[i].descuento.precio_total_taquilla);
            }

            return total;
        },
        total_descuento() {
            var total = 0;

            for (var i = 0; i < this.datos_abonados.length; i++) {
                if(this.datos_abonados[i].descuento_aplicado > 0){
                    total = total + parseFloat(this.datos_abonados[i].descuento.precio_total_taquilla * (this.datos_abonados[i].descuento_aplicado / 100));
                }
                if(this.datos_abonados[i].descuento_integro > 0){
                    total = total + (parseFloat(this.datos_abonados[i].descuento.precio_total_taquilla) - parseFloat(this.datos_abonados[i].descuento_integro));
                }
            }

            return total;
        },
        teatro() {
            return this.$store.getters.getTeatro;
        },
        permisos() {
            return this.$store.getters.getPermisos;
        }
    },
    methods: {
        reset() {
            this.resumen = false;
            this.n_simpatizantes = 1;
            this.datos= false;
            this.datos_abonados = [];
            this.forma_pago = {};
            this.urls_imprimir = null;
            this.compra_finalizada = false
            this.$nextTick(function() {
                this.scrollTo('#inicio');
            });
        },
        async submit() {
            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.finalizarPasoDos();
            }
        },
        finalizarPasoUno() {
            this.datos_abonados = [];
            for (var i = 0; i < this.n_simpatizantes; i++) {
                this.datos_abonados.push({
                    descuento_aplicado: "0",
                    descuento_integro: 0,
                });
            }
            this.datos = true;
            this.$nextTick(function() {
                this.scrollTo('#datos');
            });
        },
        finalizarPasoDos() {
            this.resumen = true;
            this.$nextTick(function() {
                this.scrollTo('#resumen');
            });
        },
        getPrecios() {
            const params = {
                filters : {
                    simpatizantes: true
                },
                lista_id: this.$store.getters.getListaId                    
            };

            this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                this.precios = res.data;
            });
        },
        scrollTo(paso) {
            this.$scrollTo(paso, 100)
        },
        finalizar() {
            this.loading = true;
            const params = {
                metodo_pago: this.forma_pago,
                datos_compradores: this.datos_abonados
            };
            this.$store.dispatch(this.config.getVuexAlias('back.simpatizantes.alta'), params).then(res => {
                this.compra_finalizada = true;
                this.urls_imprimir = res.data.urls_imprimir;
                this.loading = false;
            });
        },
        borrarMetodoDePago(metodos_de_pago, id) {
            const metodo_pago_id = metodos_de_pago.findIndex(metodo_de_pago => metodo_de_pago.id === id);
            metodos_de_pago.splice(metodo_pago_id, 1);
            return metodos_de_pago;
        },
        totalAbono(abono){
            if(abono.descuento_integro){
                return parseFloat(abono.descuento.precio_total_taquilla) - parseFloat(abono.descuento_integro);
            }

            if(abono.descuento_aplicado != "0"){
                return parseFloat(abono.descuento.precio_total_taquilla * (abono.descuento_aplicado / 100));
            }

            return 0;
        }
    },
    components: {
        MainContent,
        TitleComponent
    }
}
</script>
